import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { QuizScene, QuizHandler } from "../../lib/quiz/Quiz";
import useQuery from "../../hooks/useQuery";
import QuizQuestions from "../../components/QuizQuestions/QuizQuestions";
import QuizModeSelector from "../../components/QuizModeSelector/QuizModeSelector";
import QuizResult from "../../components/QuizResult/QuizResult";
import quizButtonCheckAnswer from "../../img/quizzes/button_check_answers.png";

interface Props {}

export default function QuizPage(props: Props) {
  const history = useRef(useHistory());
  const location = useLocation();
  const query = useRef(useQuery());
  const [quizHandler, setQuizHandler] = useState<QuizHandler>(
    new QuizHandler()
  );
  const [quizScene, setQuizScene] = useState<QuizScene>("mode-select");

  const pageTopRef = React.createRef<HTMLDivElement>();
  const scrollToTop = () => {
    pageTopRef.current!.scrollIntoView({
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const playing = params.get("playing");
    if (!playing) {
      setQuizScene("mode-select");
    }
  }, [location]);

  useEffect(() => {
    if (quizScene === "mode-select") {
      setQuizHandler(new QuizHandler());
      const playing = query.current.get("playing");
      if (playing) {
        history.current.push({
          search: new URLSearchParams({}).toString(),
        });
      }
    } else if (quizScene === "playing") {
      history.current.push({
        search: new URLSearchParams({ playing: "1" }).toString(),
      });
    }
  }, [quizScene]);

  return (
    <div className="flex items-center justify-center m-3" ref={pageTopRef}>
      {(() => {
        switch (quizScene) {
          case "playing":
          case "answers":
            return (
              <div className="max-w-3xl w-full">
                {quizScene === "answers" && (
                  <div className="my-2">
                    <QuizResult
                      quizHandler={quizHandler}
                      setQuizScene={setQuizScene}
                    ></QuizResult>
                  </div>
                )}
                <QuizQuestions
                  quizHandler={quizHandler}
                  quizScene={quizScene}
                  showAnswer={quizScene === "answers"}
                ></QuizQuestions>
                {quizScene === "playing" && (
                  <button
                    className="relative w-32 mx-auto mb-3 overflow-hidden rounded"
                    onClick={() => {
                      setQuizScene("answers");
                      scrollToTop();
                    }}
                  >
                    <img
                      className="duration-500 ease-in-out transform hover:scale-105"
                      src={quizButtonCheckAnswer}
                      alt="答え合わせ"
                    ></img>
                  </button>
                )}
              </div>
            );

          default:
            return (
              <QuizModeSelector
                quizHandler={quizHandler}
                setQuizScene={setQuizScene}
                pageTopRef={pageTopRef}
              ></QuizModeSelector>
            );
        }
      })()}
    </div>
  );
}
